import React, { useContext, useEffect, useState } from "react";
import "./DashboardHeader.css";
import logo from "../../assests/BEMSS1.png";
import { AuthContext } from "../../context/AuthContext";
import logo_img from "../../assests/user_acccount_logo.png";
import { useNavigate } from "react-router-dom";
import attendance_logo from "../../assests/attendance-logo.png"
import axios from "axios";
import BirthDayTemplate from "../BirthDayTemplate";
import Confetti from "react-confetti";
import WeddingAnniversary from "../WeddingAnniversary"
import WorkAnniversary from "../WorkAnniversary";
import ThoughtTemplate from "../../assests/thought.png"
import NotificationBar from "../../pages/NotificationBar";
import { Card, Typography, Spin, Avatar, Segmented } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function DashboardHeader({ dashboardMode, setDashboardMode, showDashboardSwitch = false }) {
    const { authData, logout, backUrl } = useContext(AuthContext);

    const [attendanceLoading, setAttendanceLoading] = useState(false);

    const [masterData, setMasterData] = useState(null);
    const [isEmployeeView, setIsEmployeeView] = useState(
        localStorage.getItem("Hrselected") === "employee"
    );
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 768;
    const [showConfetti, setShowConfetti] = useState(false);
    const [showThought, setShowThought] = useState(false);
    const [thought, setThought] = useState("");
    const [isWeddingDay, setIsWeddingDay] = useState(false);
    const [isBirthDay, setIsBirthDay] = useState(false);
    const [showBirthdayCard, setShowBirthdayCard] = useState(false);
    const [isWorkAnniversary, setIsWorkAnniversary] = useState(false);
    const [isNoRecord, setIsNoRecord] = useState(false);

    useEffect(() => {
        const thoughts = [
            "Success is the sum of small efforts repeated day in and day out.",
            "Stay positive, work hard, and make it happen.",
            "Your limitation—it's only your imagination.",
            "Great things never come from comfort zones.",
            "Push yourself, because no one else is going to do it for you.",
            "Quality means doing it right when no one is looking.",
            "Opportunities don't happen, you create them.",
            "Believe you can and you're halfway there.",
            "It always seems impossible until it's done.",
            "Dream big. Start small. But most of all, start.",
            "Action is the foundational key to all success.",
            "Excellence is not a skill, it is an attitude.",
            "Productivity is never an accident; it is always the result of commitment.",
            "Small daily improvements over time lead to stunning results.",
            "The only way to do great work is to love what you do.",
            "Don't wait for opportunity. Create it.",
            "Efficiency is doing things right; effectiveness is doing the right things.",
            "Focus on being productive instead of busy.",
            "Hard work beats talent when talent doesn't work hard.",
            "Keep your face always toward the sunshine, and shadows will fall behind you.",
            "Continuous learning is the minimum requirement for success in any field.",
            "Collaboration allows us to know more than we are capable of knowing alone.",
            "Together, ordinary people can achieve extraordinary results.",
            "Turn your obstacles into stepping stones for growth.",
            "Leadership is about making others better as a result of your presence.",
            "Consistency is what transforms average into excellence.",
            "Success isn't about greatness. It's about consistency.",
            "Innovation distinguishes between a leader and a follower.",
            "Aim for perfection, but settle for nothing less than excellence.",
            "Today's effort is tomorrow's achievement.",
            "Your energy introduces you before you even speak.",
            "Do what is right, not what is easy.",
            "Courage is resistance to fear, mastery of fear—not absence of fear.",
            "The secret of getting ahead is getting started.",
            "Set your goals high, and don't stop till you get there.",
            "Success is walking from failure to failure with no loss of enthusiasm.",
            "Don't count the days, make the days count.",
            "Small deeds done are better than great deeds planned.",
            "Great teams are built on mutual respect and shared passion.",
            "Every accomplishment starts with the decision to try.",
            "Be so good they can't ignore you.",
            "Optimism is the faith that leads to achievement.",
            "The difference between ordinary and extraordinary is that little extra.",
            "Make each day your masterpiece.",
            "Learn as if you will live forever, live like you will die tomorrow.",
            "Work hard in silence, let your success be your noise.",
            "Doubt kills more dreams than failure ever will.",
            "A champion is defined by how they recover when they fall.",
            "Patience, persistence, and perspiration make an unbeatable combination.",
            "The best preparation for tomorrow is doing your best today.",
            "You are capable of more than you know.",
            "Strive for progress, not perfection.",
            "Greatness is born out of passion and dedication.",
            "Your attitude determines your direction in life.",
            "Together we achieve more.",
            "The future depends on what you do today.",
            "Believe in yourself and all that you are.",
            "Don't let yesterday take up too much of today.",
            "Every morning brings a new potential to excel.",
            "You don't have to be great to start, but you have to start to be great.",
            "Small choices today lead to massive achievements tomorrow.",
            "Mastery comes from practice, patience, and purpose.",
            "Energy and persistence conquer all things.",
            "Focus on the solution, not the problem.",
            "Surround yourself with people who inspire you to grow.",
            "Small wins build big momentum.",
            "Clarity precedes mastery.",
            "Great work comes from a calm mind and a clear vision.",
            "Your potential is endless.",
            "Integrity is choosing courage over comfort.",
            "Keep learning, keep growing, keep pushing forward.",
            "High expectations are the key to everything.",
            "Rise up and attack the day with enthusiasm.",
            "Kindness and hard work always pay off.",
            "Be a voice, not an echo.",
            "Focus on what you can control, let go of what you cannot.",
            "Success belongs to those who prepare for it.",
            "Discipline is choosing between what you want now and what you want most.",
            "Create a life you are proud to live.",
            "Small steps every day add up to big results.",
            "Your dedication today builds your legacy tomorrow.",
            "In the middle of difficulty lies opportunity.",
            "Excellence is a habit, not a single event.",
            "Stay hungry, stay humble.",
            "The best way to predict the future is to create it.",
            "Work with purpose, lead with empathy.",
            "Great things take time; keep going.",
            "Success is built on daily habits.",
            "Celebrate every victory, no matter how small.",
            "Hard work builds character and confidence.",
            "Do what you love, love what you do.",
            "Focus on quality, speed, and precision.",
            "Knowledge speaks, but wisdom listens.",
            "Be relentless in pursuit of your goals.",
            "True strength lies in perseverance.",
            "Inspire others through your actions.",
            "Keep your vision clear and your focus sharp.",
            "Turn every challenge into an opportunity.",
            "Continuous effort unlocks your true potential.",
            "Believe in the power of teamwork.",
            "Always give 100% in everything you do."
        ];

        const randomThought = thoughts[Math.floor(Math.random() * thoughts.length)];
        setThought(randomThought);
        if (authData?.thought_for_the_day === 1) {
            setShowThought(true);
        }
        const hideTimer = setTimeout(() => {
            setShowThought(false);
        }, 8000);

        return () => clearTimeout(hideTimer);
    }, []);

    useEffect(() => {
        if (authData?.is_wedding_today) {
            setIsWeddingDay(true)
        }
        if (authData?.is_birthday_today) {
            setIsBirthDay(true)
        }
        if (authData?.is_work_anniversary_today) {
            setIsWorkAnniversary(true)
        }
    }, [authData])

    useEffect(() => {
        if (isBirthDay || isWeddingDay || isWorkAnniversary) {
            const showTimer = setTimeout(() => {
                setShowBirthdayCard(true);
                setShowConfetti(true);

                setTimeout(() => setShowConfetti(false), 5000);
                setTimeout(() => setShowBirthdayCard(false), 6000);
            }, 4000);
            return () => clearTimeout(showTimer);
        }
    }, [isBirthDay, isWeddingDay, isWorkAnniversary]);

    const handleLogout = async () => {
        await logout();
        window.location.href = "/";
    };

    const fetchData = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/hr/attendance/today/`, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            setMasterData(res.data);
            setIsNoRecord(true)
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    useEffect(() => {
        fetchData()
    }, [])

    const handleToggle = () => {
        const current = localStorage.getItem("Hrselected");

        if (current === "hr") {
            localStorage.setItem("Hrselected", "employee");
            navigate("/employee");
        } else if (current === "payroll") {
            localStorage.setItem("Hrselected", "employee");
            navigate("/employee");
        } else if (current === "employee") {
            if (authData?.employee?.is_superuser) {
                localStorage.setItem("Hrselected", "hr");
                navigate("/hrdashboard");
            } else if (authData?.employee?.is_hr && authData?.employee?.role === 2) {
                localStorage.setItem("Hrselected", "payroll");
                navigate("/payroll_hr");
            }
            else if (authData?.employee?.is_hr && authData?.employee?.role === 1) {
                localStorage.setItem("Hrselected", "onboard");
                navigate("/payroll_hr");
            } else {
                localStorage.setItem("Hrselected", "employee");
                navigate("/employee");
            }
        } else {
            localStorage.setItem("Hrselected", "employee");
            navigate("/employee");
        }
    };

    const handlePassword = async () => {
        navigate("/change_password");
    }

    const handleAttendanceClick = async () => {
        try {
            setAttendanceLoading(true);

            const getLocationPermission = () =>
                new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(
                        (pos) => resolve(pos),
                        (err) => reject(err)
                    );
                });

            const getCameraPermission = async () => {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach(track => track.stop());
            };

            await getLocationPermission();
            await getCameraPermission();

            navigate("/attendance");

        } catch (error) {
            console.error("Permission denied:", error);
            alert("Location and Camera permissions are required for attendance.");
        } finally {
            setAttendanceLoading(false);
        }
    };


    const userFullName = `${authData?.employee?.first_name || ""} ${authData?.employee?.last_name || ""}`.trim() || authData?.username || "User";
    const userDesignation = authData?.employee?.designation_name || authData?.employee?.designation || authData?.employee?.role_name || authData?.role || "HR Executive";
    const userPhoto = authData?.employee?.photo
      ? (authData.employee.photo.startsWith("http")
          ? authData.employee.photo
          : `${backUrl}${authData.employee.photo.startsWith('/') ? '' : '/'}${authData.employee.photo}`)
      : null;

    return (
        <header className="loginheader px-4 py-2">
            {/* BEMSS Logo Container — Clean Native Display */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "2px 0",
              }}
              onClick={() => navigate("/")}
            >
              <img
                src={logo}
                alt="BEMSS Logo"
                style={{
                  height: 46,
                  maxHeight: 46,
                  width: "auto",
                  objectFit: "contain",
                  filter: "drop-shadow(0 2px 8px rgba(14,73,123,0.14))",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.04)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </div>

            {/* Right Action Items Container */}
            <section style={{ display: "flex", alignItems: "center", gap: isMobile ? 10 : 16 }}>
                {/* DYNAMIC DASHBOARD MODE SWITCH FOR MANAGERS / HOD / TLS */}
                {showDashboardSwitch && setDashboardMode && (
                  <div
                    className="navbar-view-switch-container"
                    onClick={() => setDashboardMode(dashboardMode === "team" ? "self" : "team")}
                    title="Click to toggle Self View / Team View"
                  >
                    <div className={`navbar-switch-track ${dashboardMode || "self"}`}>
                      <div className={`navbar-switch-pill ${dashboardMode || "self"}`} />
                      <div className={`navbar-switch-option ${dashboardMode === "self" || !dashboardMode ? "active" : ""}`}>
                        <span className="navbar-switch-icon">👤</span>
                        <span>Self View</span>
                      </div>
                      <div className={`navbar-switch-option ${dashboardMode === "team" ? "active" : ""}`}>
                        <span className="navbar-switch-icon">👥</span>
                        <span>Team View</span>
                      </div>
                    </div>
                  </div>
                )}

                {authData?.employee?.is_checkin && (
                  <div className="attendance-wrapper" style={{ cursor: "pointer" }}>
                    <Spin spinning={attendanceLoading} size={isMobile ? "small" : "default"}>
                      <div
                        onClick={!attendanceLoading ? handleAttendanceClick : undefined}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          background: "#ffffff",
                          border: `1.5px solid ${isNoRecord ? "#16a34a" : "#ef4444"}`,
                          borderRadius: 20,
                          padding: "3px 10px 3px 6px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <img
                          src={attendance_logo}
                          alt="attendance"
                          style={{
                            width: 26,
                            height: 26,
                            borderRadius: "50%",
                          }}
                        />
                        <span style={{ fontSize: 11.5, fontWeight: 700, color: "#0e497b" }}>
                          Attendance
                        </span>
                      </div>
                    </Spin>
                  </div>
                )}

                {authData?.employee?.is_hr === true && (
                  <div
                    onClick={handleToggle}
                    className="hr-workspace-toggle-badge"
                    title={isEmployeeView ? "Click to switch to HR Portal" : "Click to switch to Employee Portal"}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      background: isEmployeeView
                        ? "linear-gradient(135deg, #0e497b 0%, #1d4ed8 100%)"
                        : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                      color: "#ffffff",
                      padding: "5px 14px 5px 10px",
                      borderRadius: 30,
                      cursor: "pointer",
                      fontWeight: 800,
                      fontSize: 12,
                      boxShadow: isEmployeeView
                        ? "0 4px 14px rgba(14,73,123,0.32)"
                        : "0 4px 14px rgba(16,185,129,0.35)",
                      transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                      border: "1px solid rgba(255,255,255,0.25)",
                      userSelect: "none",
                    }}
                  >
                    <div
                      style={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "#ffffff",
                        color: isEmployeeView ? "#0e497b" : "#059669",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 11,
                        fontWeight: 900,
                        boxShadow: "0 2px 4px rgba(0,0,0,0.18)"
                      }}
                    >
                      {isEmployeeView ? "👤" : "💼"}
                    </div>
                    <span>{isEmployeeView ? "Employee Mode" : "HR Mode"}</span>
                    <span style={{ fontSize: 10, opacity: 0.8, marginLeft: 2 }}>⇄</span>
                  </div>
                )}

                {/* Notification Bell */}
                <NotificationBar backUrl={backUrl} authData={authData} />

                {/* Account Profile Dropdown */}
                <div className="dropdown d-flex align-items-center">
                  <div
                    className="d-flex align-items-center gap-2 account-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      background: "#ffffff",
                      border: "1px solid #e2e8f0",
                      padding: "5px 12px 5px 10px",
                      borderRadius: 12,
                      boxShadow: "0 2px 6px rgba(15,23,42,0.04)",
                      cursor: "pointer",
                    }}
                  >
                    <Avatar
                      size={34}
                      src={userPhoto}
                      style={{
                        background: "linear-gradient(135deg, #0e497b 0%, #1d4ed8 100%)",
                        color: "#fff",
                        fontWeight: 800,
                        fontSize: 13,
                        boxShadow: "0 2px 6px rgba(14,73,123,0.25)",
                        border: "1.5px solid #ffffff",
                        flexShrink: 0,
                      }}
                      icon={!userPhoto && !userFullName && <UserOutlined />}
                    >
                      {!userPhoto && (userFullName ? userFullName[0]?.toUpperCase() : "U")}
                    </Avatar>
                    <div style={{ textAlign: "left", lineHeight: 1.2 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>
                        {userFullName}
                      </div>
                      <div style={{ fontSize: 10.5, color: "#64748b", fontWeight: 600 }}>
                        {userDesignation}
                      </div>
                    </div>
                    <DownOutlined style={{ fontSize: 10, color: "#94a3b8", marginLeft: 4 }} />
                  </div>
                  <ul className="dropdown-menu dropdown-menu-end shadow-sm" style={{ borderRadius: 10, border: "1px solid #e2e8f0", padding: "6px 0" }}>
                    <li>
                      <button className="dropdown-item" onClick={handlePassword}>Change Password</button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
            </section>

            {(isWeddingDay || isBirthDay || isWorkAnniversary) && showBirthdayCard && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        animation: "fadeIn 0.5s ease",
                    }}
                    onClick={() => setShowBirthdayCard(false)}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: "30px",
                            zIndex: 10000,
                            animation: "popIn 0.6s ease",
                        }}
                    >
                        {isBirthDay && (
                            <div className="hanging-animation">
                                <BirthDayTemplate employee={authData?.employee} />
                            </div>
                        )}

                        {isWeddingDay && (
                            <div className="hanging-animation">
                                <WeddingAnniversary employee={authData?.employee} type="wedding" />
                            </div>
                        )}

                        {isWorkAnniversary && (
                            <div className="hanging-animation">
                                <WorkAnniversary employee={authData?.employee} type="anniversary" />
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showConfetti && (
                <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    numberOfPieces={250}
                    gravity={0.3}
                    recycle={false}
                />
            )}

            {showThought && (
                <div
                    style={{
                        position: "fixed",
                        top: isMobile ? 70 : 80,
                        right: isMobile ? 10 : 30,
                        width: isMobile ? "92%" : 320,
                        height: isMobile ? 190 : 210,
                        zIndex: 9999,
                        animation: "fadeInOut 5s ease forwards",
                    }}
                >
                    <Card
                        bordered={false}
                        style={{
                            height: "100%",
                            borderRadius: 18,
                            overflow: "hidden",
                            backgroundImage: `url(${ThoughtTemplate})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                            backdropFilter: "blur(6px)",
                            border: "1px solid rgba(14,73,123,0.4)",
                        }}
                        bodyStyle={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            padding: "20px",
                            background: "rgba(255,255,255,0.65)", // glass overlay
                        }}
                    >
                        {/* Title */}
                        <Title
                            level={5}
                            style={{
                                marginBottom: 12,
                                fontStyle: "italic",
                                color: "#0e497b",
                            }}
                        >
                            🌞 Thought for the Day
                        </Title>

                        {/* Thought Text */}
                        <Text
                            style={{
                                fontSize: 15,
                                lineHeight: 1.6,
                                color: "#063970",
                                fontStyle: "italic",
                                maxWidth: "85%",
                            }}
                        >
                            "{thought}"
                        </Text>
                    </Card>
                </div>
            )}
        </header>
    );
}